import script from "./return-document.vue?vue&type=script&lang=ts&setup=true"
export * from "./return-document.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__